"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Chart: () => Chart,
  TooltipHeader: () => TooltipHeader,
  TooltipTitle: () => TooltipTitle,
  TooltipWrapper: () => TooltipWrapper
});
module.exports = __toCommonJS(src_exports);

// src/Chart.tsx
var import_react2 = require("react");
var import_server2 = require("react-dom/server");
var import_lodash = __toESM(require("lodash.merge"));
var import_highcharts = __toESM(require("highcharts"));
var import_stock = __toESM(require("highcharts/modules/stock"));
var import_accessibility = __toESM(require("highcharts/modules/accessibility"));
var import_highcharts_react_official = __toESM(require("highcharts-react-official"));

// src/ChartTooltip.tsx
var import_react = require("react");
var import_server = require("react-dom/server");
var import_styled_components = __toESM(require("styled-components"));
var import_legacy_components = require("@studio/legacy-components");

// src/date.ts
var import_moment = __toESM(require("moment"));
import_moment.default.suppressDeprecationWarnings = true;
var format = (date, tokens) => {
  return (0, import_moment.default)(date).format(tokens);
};
var utc = (date) => {
  return (0, import_moment.default)(date).utc();
};

// src/ChartTooltip.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Wrapper = import_styled_components.default.div`
  background-color: var(--foreground-tooltip, var(--white));
  border-radius: 6px;
  box-shadow: var(--elevation-300, var(--level-3));
  font-size: var(--font-size-small, var(--x-small));
  pointer-events: auto;
`;
var Title = import_styled_components.default.div`
  background-color: var(--noreaster);
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  color: var(--pleather);
  font-weight: var(--bold);
  padding: 8px 24px;
`;
var GridItem = import_styled_components.default.div`
  margin: 0px 8px 8px 0px;
  display: flex;
  align-items: center;
`;
var NameHeader = (0, import_styled_components.default)(GridItem)`
  font-weight: bold;
  grid-column: 1 / 3;
`;
var ValueHeader = (0, import_styled_components.default)(GridItem)`
  font-weight: bold;
  grid-column: 3 / 4;
  text-align: center;
  justify-content: center;
`;
var Points = import_styled_components.default.div`
  align-items: center;
  display: grid;
  gap: 12px;
  padding: 12px 24px 12px 24px;
  grid-template-columns: auto auto auto;
`;
var Clamp = import_styled_components.default.p`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  max-height: 3.4em;
  line-height: 1.4em;
  margin: 0;
`;
var Marker = (0, import_styled_components.default)(import_legacy_components.Icon)`
  color: ${({ color }) => color};
  font-size: 8px;
`;
var Name = import_styled_components.default.span`
  width: 250px;
`;
var Value = import_styled_components.default.span`
  font-weight: var(--bold);
  text-align: ${({ hasHeader }) => hasHeader ? "center" : "right"};
`;
var SimpleTooltip = import_styled_components.default.div`
  background: var(--smurf-blood);
  border-color: var(--smurf-blood);
  border-radius: 6px;
  color: var(--white);
  font-weight: var(--normal);
  font-size: var(--x-small);
  line-height: 1.5;
  padding: 10px 12px;
`;
var number = (value) => new Intl.NumberFormat().format(value);
function ChartTooltip({
  points,
  publishInfo,
  title,
  headers = ["", ""],
  valuePrefix = "",
  valueSuffix = ""
}) {
  const topic = format(utc(title), "dddd, MMM D, YYYY");
  const [nameHeader, valueHeader] = headers;
  return points ? /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Wrapper, {
    children: [
      /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Title, {
        children: topic
      }),
      /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Points, {
        children: [
          nameHeader && valueHeader && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, {
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(NameHeader, {
                children: nameHeader
              }),
              /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ValueHeader, {
                children: valueHeader
              })
            ]
          }),
          points.map(
            ({ color, series: { name }, point: { y: value }, ...point }) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_react.Fragment, {
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Marker, {
                  color,
                  icon: "circle"
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Name, {
                  children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(Clamp, {
                    children: name
                  })
                }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(Value, {
                  hasHeader: Boolean(valueHeader),
                  children: [
                    valuePrefix,
                    number(value),
                    valueSuffix
                  ]
                })
              ]
            }, point.x)
          )
        ]
      })
    ]
  }) : /* @__PURE__ */ (0, import_jsx_runtime.jsx)(SimpleTooltip, {
    children: publishInfo
  });
}

// src/Chart.tsx
var import_jsx_runtime = require("react/jsx-runtime");
(0, import_stock.default)(import_highcharts.default);
(0, import_accessibility.default)(import_highcharts.default);
var container = {
  style: {
    height: "100%",
    width: "100%"
  }
};
var base = {
  chart: {
    animation: false,
    height: 400,
    style: {
      fontFamily: "Mulish, Helvetica Neue, sans-serif"
    }
  },
  colors: ["#9D9DFF", "#FF97BC", "#6FDDDB", "#FFBB61"],
  credits: {
    enabled: false
  },
  legend: {
    align: "left",
    margin: 24,
    itemDistance: 16,
    itemHiddenStyle: {
      color: "var(--text-tertiary)"
    },
    itemHoverStyle: {
      color: "var(--text-secondary)"
    },
    itemStyle: {
      color: "var(--text-primary)"
    },
    symbolHeight: 12,
    symbolWidth: 12,
    symbolRadius: 6,
    verticalAlign: "top"
  },
  plotOptions: {
    series: {
      animation: false,
      marker: {
        symbol: "circle"
      }
    }
  },
  time: {
    useUTC: true
  },
  title: {
    text: void 0
  },
  tooltip: {
    padding: 12,
    shared: true,
    useHTML: true,
    borderWidth: 0,
    backgroundColor: "none",
    shadow: false,
    positioner(labelWidth, labelHeight, point) {
      const {
        plotLeft: chartPlotLeft,
        plotTop: chartPlotTop,
        plotWidth: chartPlotWidth,
        chartHeight,
        hoverPoint
      } = this.chart;
      const {
        series: { type }
      } = hoverPoint;
      const { plotX, plotY } = point;
      const tooltipLeftX = chartPlotLeft + plotX - labelWidth;
      const tooltipRightX = chartPlotLeft + plotX;
      let tooltipY = chartPlotTop + plotY - labelHeight / 2;
      if (tooltipY < 0) {
        tooltipY -= tooltipY;
      }
      if (tooltipY + labelHeight > chartHeight) {
        tooltipY -= chartPlotTop + chartHeight - (tooltipY + labelHeight);
      }
      if (type === "flags") {
        tooltipY -= 126;
      }
      return {
        x: tooltipRightX + labelWidth > chartPlotLeft + chartPlotWidth ? tooltipLeftX : tooltipRightX,
        y: tooltipY
      };
    }
  },
  xAxis: {
    dateTimeLabelFormats: {
      day: "%b %e",
      week: "%b %e",
      month: "%b '%y"
    },
    title: {
      margin: 16,
      style: {
        color: "var(--foreground-primary)",
        fontWeight: "var(--semi-bold)"
      },
      text: "Date"
    },
    type: "datetime"
  },
  yAxis: {
    allowDecimals: false,
    height: "90%",
    top: "10%",
    min: 0,
    minRange: 1,
    title: {
      margin: 12,
      style: {
        color: "var(--foreground-primary)",
        fontWeight: "var(--semi-bold)"
      },
      text: "Count"
    }
  }
};
function Chart({
  options: overrides,
  series,
  tooltipHeaders,
  Tooltip
}) {
  var _a, _b;
  const formatter = (0, import_react2.useCallback)(
    function renderTooltip() {
      var _a2, _b2;
      const TooltipComponent = Tooltip != null ? Tooltip : ChartTooltip;
      const { key, points, x } = this;
      return (0, import_server2.renderToStaticMarkup)(
        /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TooltipComponent, {
          points,
          title: x,
          publishInfo: `${key}`,
          headers: tooltipHeaders != null ? tooltipHeaders : [],
          valuePrefix: (_a2 = overrides == null ? void 0 : overrides.tooltip) == null ? void 0 : _a2.valuePrefix,
          valueSuffix: (_b2 = overrides == null ? void 0 : overrides.tooltip) == null ? void 0 : _b2.valueSuffix
        })
      );
    },
    [
      Tooltip,
      (_a = overrides == null ? void 0 : overrides.tooltip) == null ? void 0 : _a.valuePrefix,
      (_b = overrides == null ? void 0 : overrides.tooltip) == null ? void 0 : _b.valueSuffix,
      tooltipHeaders
    ]
  );
  const options = (0, import_react2.useMemo)(() => {
    var _a2;
    const merged = (0, import_lodash.default)({}, base, { tooltip: { formatter } }, overrides);
    if ((_a2 = overrides == null ? void 0 : overrides.tooltip) == null ? void 0 : _a2.outside) {
      delete merged.tooltip.positioner;
    }
    return { ...merged, series };
  }, [formatter, overrides, series]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_highcharts_react_official.default, {
    containerProps: container,
    highcharts: import_highcharts.default,
    options
  });
}

// src/Tooltip.tsx
var import_styled_components2 = __toESM(require("styled-components"));
var TooltipWrapper = import_styled_components2.default.div`
  border-radius: 6px;
  box-shadow: var(--level-3);
  font-size: var(--x-small);
  background-color: #fff;
  pointer-events: auto;
`;
var TooltipHeader = import_styled_components2.default.div`
  background-color: var(--tooltip-header-bg);
  color: var(--tooltip-header-color);
  border-radius: 6px 6px 0 0;
  padding: 8px 24px;
`;
var TooltipTitle = import_styled_components2.default.h3`
  font-weight: var(--bold);
  font-size: ${({ size }) => {
  switch (size) {
    case "xxs":
      return "var(--xx-small)";
    case "xs":
      return "var(--x-small)";
    case "s":
      return "var(--small)";
    case "m":
      return "var(--regular)";
    case "ml":
      return "var(--medium-large)";
    case "l":
      return "var(--large)";
    case "xl":
      return "var(--x-large)";
    case "xxl":
      return "var(--x-large)";
    default:
      return "var(--regular)";
  }
}};
`;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Chart,
  TooltipHeader,
  TooltipTitle,
  TooltipWrapper
});
//# sourceMappingURL=index.js.map